export type CityKey = 'tokyo' | 'osaka' | 'kyoto' | 'hongkong' | 'taipei' | 'fuji' | 'singapore' | 'macau' | 'bangkok';

const CITY_ALIASES: Record<CityKey, string[]> = {
  tokyo: ['tokyo', '东京', '東京', 'とうきょう', 'tokio', 'jp-tokyo'],
  osaka: ['osaka', '大阪', 'おおさか', 'jp-osaka'],
  kyoto: ['kyoto', '京都', 'きょうと', 'jp-kyoto'],
  hongkong: ['hong kong', '香港', '香 港', 'hk', 'hongkong'],
  taipei: ['taipei', '台北', '臺北', 'たいぺい'],
  fuji: ['fuji', '富士山', '富士', 'ふじ'],
  singapore: ['singapore', '新加坡', 'singapura', 'sg'],
  macau: ['macau', '澳门', '澳門', 'macao', 'mo', 'mo-澳門', 'mo-澳门'],
  bangkok: ['bangkok', '曼谷', 'bkk', 'กรุงเทพ', 'กรุงเทพมหานคร', 'th-bangkok'],
};

const CITY_DISPLAY_ZH: Record<CityKey, string> = {
  tokyo: '东京',
  osaka: '大阪',
  kyoto: '京都',
  hongkong: '香港',
  taipei: '台北',
  fuji: '富士山',
  singapore: '新加坡',
  macau: '澳门',
  bangkok: '曼谷',
};

export const resolveCityKey = (input?: string | null): CityKey | null => {
  if (!input) return null;
  const norm = (input || '').toString().toLowerCase().trim();
  // exact key
  if ((Object.keys(CITY_ALIASES) as CityKey[]).includes(norm as CityKey)) return norm as CityKey;
  // alias contains, split by comma if needed
  const tokens = norm.split(',').map((s) => s.trim()).filter(Boolean);
  const candidates = tokens.length ? tokens : [norm];
  for (const key of Object.keys(CITY_ALIASES) as CityKey[]) {
    for (const alias of CITY_ALIASES[key]) {
      if (candidates.some((t) => t === alias)) return key;
    }
  }
  return null;
};

export const getCityDisplayNameZH = (key: CityKey): string => CITY_DISPLAY_ZH[key] || key;